import route from 'route';

const mainRoute = route.DASHBOARD;
const deliveryRoute = `${mainRoute}/delivery`;

export default {
  ORDER_LIST: `${deliveryRoute}/order-list`,
  ORDER_LIST_FILTER: `${deliveryRoute}/order-list/page/:page`,
  ORDER_DETAIL: `${deliveryRoute}/order-detail/:id`,
  PARTNER_LIST: `${deliveryRoute}/partner-list`,
  PARTNER_LIST_FILTER: `${deliveryRoute}/partner-list/page/:page`,
  PARTNER_DETAIL: `${deliveryRoute}/partner-detail/:id`,
  PARTNER_EDIT: `${deliveryRoute}/partner-detail/:id/edit`,
  CLIENT_LIST: `${deliveryRoute}/client-list`,
  CLIENT_LIST_FILTER: `${deliveryRoute}/client-list/page/:page`,
};
